/* tslint:disable */
/* eslint-disable */
/**
 * All APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CardPaymentMethod
 */
export interface CardPaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof CardPaymentMethod
     */
    type: CardPaymentMethodTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof CardPaymentMethod
     */
    brand: string;
    /**
     * 
     * @type {string}
     * @memberof CardPaymentMethod
     */
    last4: string;
    /**
     * 
     * @type {number}
     * @memberof CardPaymentMethod
     */
    expiryYear: number;
    /**
     * 
     * @type {number}
     * @memberof CardPaymentMethod
     */
    expiryMonth: number;
}


/**
 * @export
 */
export const CardPaymentMethodTypeEnum = {
    Card: 'card'
} as const;
export type CardPaymentMethodTypeEnum = typeof CardPaymentMethodTypeEnum[keyof typeof CardPaymentMethodTypeEnum];


/**
 * Check if a given object implements the CardPaymentMethod interface.
 */
export function instanceOfCardPaymentMethod(value: object): value is CardPaymentMethod {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('brand' in value) || value['brand'] === undefined) return false;
    if (!('last4' in value) || value['last4'] === undefined) return false;
    if (!('expiryYear' in value) || value['expiryYear'] === undefined) return false;
    if (!('expiryMonth' in value) || value['expiryMonth'] === undefined) return false;
    return true;
}

export function CardPaymentMethodFromJSON(json: any): CardPaymentMethod {
    return CardPaymentMethodFromJSONTyped(json, false);
}

export function CardPaymentMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): CardPaymentMethod {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'brand': json['brand'],
        'last4': json['last4'],
        'expiryYear': json['expiryYear'],
        'expiryMonth': json['expiryMonth'],
    };
}

export function CardPaymentMethodToJSON(json: any): CardPaymentMethod {
    return CardPaymentMethodToJSONTyped(json, false);
}

export function CardPaymentMethodToJSONTyped(value?: CardPaymentMethod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'brand': value['brand'],
        'last4': value['last4'],
        'expiryYear': value['expiryYear'],
        'expiryMonth': value['expiryMonth'],
    };
}

